const
  NAME               = 'tabBind',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME]
;

class TabBind {
  constructor(element$) {
    this._element$ = element$;
    this._element$.on('shown.bs.tab', this.onClick.bind(this));
  }

  onClick(/*event*/){
    let tabBinded = $('a[href="' + this._element$.attr('href') + '"]');
    tabBinded.closest('li').siblings().removeClass('active');
    tabBinded.closest('li').addClass('active');
    tabBinded.addClass('active');
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(/*config*/) {
    return this.each(function() {
      new TabBind($(this));
    });
  }
}

$.fn[NAME]             = TabBind._jQueryInterface;
$.fn[NAME].Constructor = TabBind;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return TabBind._jQueryInterface;
};

export default TabBind;



// WEBPACK FOOTER //
// ./src/plugins/tab-bind.js